import(/* webpackMode: "eager", webpackExports: ["IFrameEntryPoint"] */ "/app/src/components/entry-points/IFrameEntryPoint/index.tsx");
